import { produce } from 'immer'
import { capitalize, findIndex, forEach, map, startCase } from 'lodash'
import { Status, TrialData } from '../apis/trial.api'
import { ActionName } from '../components/Actions'
import { LabelType } from '../components/Label'
import { TableHorizontalData } from '../components/TableHorizontal'

const trialStatusBadges: Record<Status, LabelType> = {
  'email unverified': 'dark',
  'email verified': 'warning',
  approved: 'success',
  rejected: 'gray',
  expired: 'danger',
  onboarded: 'success',
  closed: 'gray'
}

export default {
  tableHorizontalData (
    trials: TrialData[]
  ): TableHorizontalData<TrialData>[] {
    forEach(trials, (trial: TableHorizontalData<TrialData>) => {
      const actions: ActionName[] = []
      if (trial.status === 'email verified') {
        actions.push('accept')
        actions.push('reject')
      } else if (trial.status === 'expired') {
        actions.push('onboard')
        actions.push('close')
      }
      trial.typeText = capitalize(startCase(trial.type))
      trial.badge = trialStatusBadges[trial.status]
      trial.actions = actions
    })
    return trials
  },

  updateStatus (
    trials: TableHorizontalData<TrialData>[],
    id: number,
    status: Status
  ) {
    return produce(trials, trials => {
      const index = findIndex(trials, { id })
      if (index === -1) return
      const trial = trials[index]
      trial.status = status
      trial.badge = trialStatusBadges[status]
      trial.actions = []
      trials.splice(index, 1, trials[index])
    })
  },

  roleSelectOptions () {
    const roles = [
      'Manager',
      'Production or Inventory',
      'Designer/Creator',
      'Operations',
      'Sales & Marketing',
      'Executive',
      'Individual',
      'Other'
    ]
    return map(roles, role => {
      return { name: role, value: role }
    })
  }
}
